import { inject } from 'aurelia-framework';
import { Api } from '../services/api';
import { AuthRequest, DataService } from '../services/data-service';

@inject(DataService, Api)
export class AccountInfo {
	/* MARK: Component life cycle
	   =================================
	*/

	constructor(ds, api){ this.ds = ds; this.api = api;}

	attached(){
		// Init - get user
		window.setTimeout( () => { this.init(); }, 600);
	}

	init(){
		this.getUserInfo(this.ds.token).then(response => {
			this.handleGetUserInfoResponse(response);
		});
	}

	/* MARK: API Calls
	   =================================
	*/

	getUserInfo(token){
		// User credentials from DataService
		let	uid			= this.ds.user.uid;
		let authRequest = new AuthRequest("/api/v2/users/uid?", "GET");
		let query		= new URLSearchParams({ uid: uid});
		authRequest.url = authRequest.url + query;
		authRequest.headers["Authorization"] = "Bearer" + token;
		return this.api.get(authRequest);
	}

	handleGetUserInfoResponse(response){
		this.ds.user_info = response.data;
		this.user_info	  = response.data;
	}

	/* MARK: Custom methods
	   =================================
	*/

	displayDate(date){ return new Date(date).toDateString();}
	backNavi(){ if(history.length != 0){history.back();}}
}
